import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import Dumbo from '../Dumbo';
import PremiumIcon from '../Helper/PremiumIcon';
import s from './DumboWithIcon.scss';
// The icon is shown on premium deviations
export var DumboWithIcon = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement(Dumbo, __assign({}, props)),
        React.createElement(PremiumIcon, { className: s['icon'], premiumFolderData: props.deviation.premiumFolderData, tooltipClassName: s['tooltip'] })));
};
DumboWithIcon.displayName = 'DumboWithIcon';
export default DumboWithIcon;
//# sourceMappingURL=DumboWithIcon.js.map